import React from 'react';
import {Form, InputGroup, Modal, ButtonToolbar, Button, ToggleButton, ToggleButtonGroup} from 'react-bootstrap';
import Icofont from 'react-icofont';

class AddAddressModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            city: "",
            phone: "",
            zipCode: "",
            email: "",
            region: "",
            street: "",
            stockwerk: "",
            houseNumber: "",
            message: "",
            errors: {}
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    saveAddress() {
        const data = JSON.parse(localStorage.getItem("addresses") || "[]");

        const newId = data.length > 0 ? Math.max(...data.map((item) => item.id)) + 1 : 1;

        const newItem = {id: newId, ...this.state};

        data.push(newItem);
        localStorage.setItem("addresses", JSON.stringify(data));

        this.setState({
            firstName: "",
            lastName: "",
            phone: "",
            zipCode: "",
            email: "",
            city: "",
            street: "",
            houseNumber: "",
            stockwerk: "",
            message: "",
            errors: {} // Очищаємо помилки
        });
    }


    handleInputChange(event) {
        // this.setState({ [event.target.name]: event.target.value });
        const {name, value} = event.target;
        this.setState({[name]: value, errors: {...this.state.errors, [name]: ""}});
    }

    onFormSubmit() {
        const {firstName, lastName, phone, zipCode, email, city, street, houseNumber} = this.state;
        let errors = {};

        // Перевіряємо обов'язкові поля
        if (!firstName) errors.firstName = "Dieses Feld ist Pflichtfeld!";
        if (!lastName) errors.lastName = "Dieses Feld ist Pflichtfeld!";
        if (!phone) errors.phone = "Dieses Feld ist Pflichtfeld!";
        if (!zipCode) errors.zipCode = "Dieses Feld ist Pflichtfeld!";
        if (!email) errors.email = "Dieses Feld ist Pflichtfeld!";
        if (!city) errors.city = "Dieses Feld ist Pflichtfeld!";
        if (!street) errors.street = "Dieses Feld ist Pflichtfeld!";
        if (!houseNumber) errors.houseNumber = "Dieses Feld ist Pflichtfeld!";

        // Валідація email
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailPattern.test(email)) {
            errors.email = "Geben Sie die richtige E-Mail-Adresse ein!";
        }

        // Якщо є помилки, оновлюємо state і зупиняємо сабміт
        if (Object.keys(errors).length > 0) {
            this.setState({errors});
            return;
        }

        this.saveAddress();

        this.props.onSuccess(this.state);
        this.props.onHide();
    }

    render() {
        const {errors} = this.state;

        return (
            <Modal show={this.props.show} onHide={this.props.onHide} centered>
                <Modal.Header closeButton={true}>
                    <Modal.Title as='h5' id="add-address">Lieferinformationen hinzufügen</Modal.Title>
                </Modal.Header>

                {/*<Modal.Body>*/}
                {/*    <Form>*/}
                {/*        <div className="form-row col-md-12">*/}
                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Vorname*</small></Form.Label>*/}
                {/*                <InputGroup>*/}
                {/*                    <Form.Control type="text" name="firstName" value={this.state.firstName} onChange={this.handleInputChange} placeholder="Vorname" required/>*/}
                {/*                    /!* <InputGroup.Append>*/}
                {/*                        <Button variant="outline-secondary" type="button" id="button-addon2"><Icofont icon="ui-pointer"/></Button>*/}
                {/*                    </InputGroup.Append> *!/*/}
                {/*                </InputGroup>*/}
                {/*            </Form.Group>*/}
                {/*            */}
                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Nachname*</small></Form.Label>*/}
                {/*                <Form.Control type="text" name="lastName" value={this.state.lastName} onChange={this.handleInputChange} placeholder="Nachname" required />*/}
                {/*            </Form.Group>*/}

                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Telefon*</small></Form.Label>*/}
                {/*                <Form.Control type="tel" name="phone" value={this.state.phone} onChange={this.handleInputChange} placeholder="Telefon" required />*/}
                {/*            </Form.Group>*/}

                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Postleitzahl*</small></Form.Label>*/}
                {/*                <Form.Control type="text" name="zipCode" value={this.state.zipCode} onChange={this.handleInputChange} placeholder="Postleitzahl" required />*/}
                {/*            </Form.Group>*/}

                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>E-Mail*</small></Form.Label>*/}
                {/*                <Form.Control type="email" name="email" value={this.state.email} onChange={this.handleInputChange} placeholder="E-Mail" required />*/}
                {/*            </Form.Group>*/}

                {/*            /!* <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Region*</small></Form.Label>*/}
                {/*                <Form.Control type="text" placeholder="Region" required />*/}
                {/*            </Form.Group> *!/*/}
                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Stadt*</small></Form.Label>*/}
                {/*                <Form.Control type="text" name="city" value={this.state.city} onChange={this.handleInputChange} placeholder="Stadt" required />*/}
                {/*            </Form.Group>*/}

                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Straße*</small></Form.Label>*/}
                {/*                <Form.Control type="text" name="street" value={this.state.street} onChange={this.handleInputChange} placeholder="Straße" required />*/}
                {/*            </Form.Group>*/}

                {/*            <Form.Group className="col-md-6">*/}
                {/*                <Form.Label><small>Hausnummer*</small></Form.Label>*/}
                {/*                <Form.Control type="text" name="houseNumber" value={this.state.houseNumber} onChange={this.handleInputChange} placeholder="Hausnummer" required />*/}
                {/*            </Form.Group>*/}

                {/*            <Form.Group className="col-md-12" controlId="exampleForm.ControlTextarea1">*/}
                {/*                <Form.Label><small>Kommentar</small></Form.Label>*/}
                {/*                <Form.Control as="textarea" name="message" value={this.state.message} onChange={this.handleInputChange} rows={6} cols={5} resize-none required placeholder="Ihr Kommentar" />*/}
                {/*            </Form.Group>*/}

                {/*            /!* <Form.Group className="mb-0 col-md-12">*/}
                {/*            <Form.Label>Nickname</Form.Label>*/}
                {/*            <ButtonToolbar>*/}
                {/*                <ToggleButtonGroup className="d-flex w-100" type="radio" name="options" defaultValue={1}>*/}
                {/*                                <ToggleButton variant='info' value={1}>*/}
                {/*                                Home*/}
                {/*                                </ToggleButton>*/}
                {/*                                <ToggleButton variant='info' value={2}>*/}
                {/*                                Work*/}
                {/*                                </ToggleButton>*/}
                {/*                                <ToggleButton variant='info' value={3}>*/}
                {/*                                Other*/}
                {/*                                </ToggleButton>*/}
                {/*                            </ToggleButtonGroup>*/}
                {/*                        </ButtonToolbar>*/}
                {/*            </Form.Group> *!/*/}
                {/*        </div>*/}
                {/*    </Form>      */}
                {/*</Modal.Body>*/}

                {/*<Modal.Footer>*/}
                {/*    <Button type='button' onClick={this.props.onHide} variant="outline-primary" className="d-flex w-50 text-center justify-content-center">CANCEL</Button>*/}
                {/*    <Button type='button' onClick={this.onFormSubmit} variant="primary" className='d-flex w-50 text-center justify-content-center'>SUBMIT</Button>*/}
                {/*</Modal.Footer>*/}

                <Modal.Body>
                    <Form>
                        <div className="form-row col-md-12">
                            {[
                                {name: "firstName", label: "Vorname", type: "text", required: true},
                                {name: "lastName", label: "Nachname", type: "text", required: true},
                                {name: "phone", label: "Telefon", type: "tel", required: true},
                                {name: "zipCode", label: "Postleitzahl", type: "text", required: true},
                                {name: "email", label: "E-Mail", type: "email", required: true},
                                {name: "city", label: "Stadt", type: "text", required: true},
                                {name: "street", label: "Straße", type: "text", required: true},
                                {name: "houseNumber", label: "Hausnummer", type: "text", required: true},
                                {name: "stockwerk", label: "Stockwerk", type: "text", required: false}
                            ].map(({name, label, type, required}) => (
                                <Form.Group key={name} className="col-md-6">
                                    <Form.Label><small>{label}{required ? "*" : ""}</small></Form.Label>
                                    <Form.Control
                                        type={type}
                                        name={name}
                                        value={this.state[name]}
                                        onChange={this.handleInputChange}
                                        placeholder={label}
                                        className={errors[name] ? "is-invalid" : ""}
                                        required={required}
                                    />
                                    {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
                                </Form.Group>
                            ))}

                            <Form.Group className="col-md-12">
                                <Form.Label><small>Kommentar</small></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="message"
                                    value={this.state.message}
                                    onChange={this.handleInputChange}
                                    rows={6}
                                    className={errors.message ? "is-invalid" : ""}
                                    placeholder="Ihr Kommentar"
                                />
                            </Form.Group>
                        </div>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button type="button" onClick={this.props.onHide} variant="outline-primary"
                            className="d-flex w-50 text-center justify-content-center">ABBRECHEN</Button>
                    <Button type="button" onClick={this.onFormSubmit} variant="primary"
                            className="d-flex w-50 text-center justify-content-center">SPEICHERN</Button>
                </Modal.Footer>

            </Modal>
        );
    }
}

export default AddAddressModal;